import { acceptPhoneValue } from '../../field-viewer/shared-normalizers';
export const phoneViewer = {
    normalizeLoadedValue: acceptPhoneValue
};

//# sourceMappingURL=definition-viewer.js.map